/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Item { 
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    id?: number;
    skuId?: number;
    outerOrderNo?: string;
    innerOrderNo: string;
    outerItemId?: number;
    spuCode?: string;
    spuType?: number;
    skuCode?: string;
    spuName?: string;
    skuName?: string;
    quantity?: number;
    refundQty?: number;
    returnQty?: number;
    setFlag?: number;
    fulfillmentMode?: Item.FulfillmentModeEnum;
    giftFlag?: number;
    multiFlag?: number;
    exceptionFlag?: number;
    deleteFlag?: number;
    endorseStatus?: string;
    preemptionStatus?: string;
    sourceStatus?: string;
    deliveryStatus?: string;
    syncPreempStatus?: string;
    syncDeliveryStatus?: string;
    refundFlag?: number;
    suspendStatus?: string;
    storeId?: number;
    orderItemCode?: string;
    mainItemCode?: string;
    tags?: string;
    systemPickFlag?: boolean;
    activityId?: number;
    receivingStatus?: string;
    /**
     * Total external sales price
     */
    outerSaleAmount?: number;
    /**
     * External sales unit price
     */
    outerSingleSaleAmount?: number;
    /**
     * Total internal sales price
     */
    innerSaleAmount?: number;
    /**
     * Internal sales unit price
     */
    innerSingleSaleAmount?: number;
    /**
     * Cost price, unit of measurement: USD, keep 2 decimal places
     */
    costPrice?: number;
    /**
     * Fare
     */
    transPrice?: number;
}
export namespace Item {
    export const FulfillmentModeEnum = {
        VirtualBundle: 'VIRTUAL_BUNDLE',
        PrePacked: 'PRE_PACKED'
    } as const;
    export type FulfillmentModeEnum = typeof FulfillmentModeEnum[keyof typeof FulfillmentModeEnum];
}


